
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { Json } from '@/integrations/supabase/types';

export const usePollsterData = (userId: string | undefined) => {
  const [pollStats, setPollStats] = useState({
    totalPolls: 0,
    activePolls: 0
  });
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState<any[]>([]);

  useEffect(() => {
    const fetchPollsterData = async () => {
      if (!userId) return;
      
      try {
        setLoading(true);
        
        // Fetch poll stats
        const { data: pollVotes, error: pollError } = await supabase
          .from('poll_votes')
          .select('poll_id, option_id')
          .eq('user_id', userId);
          
        if (pollError) throw pollError;
        
        // Get active polls count
        const { data: activePolls, error: activeError } = await supabase
          .from('polls')
          .select('id')
          .eq('status', 'live');
          
        if (activeError) throw activeError;
          
        // Fetch documents
        const { data: docs, error: docsError } = await supabase
          .from('user_id_documents')
          .select('*')
          .eq('user_id', userId);
          
        if (docsError) throw docsError;
        
        setPollStats({
          totalPolls: pollVotes?.length || 0,
          activePolls: activePolls?.length || 0
        });
        
        setDocuments(docs || []);
      } catch (error) {
        console.error('Error fetching pollster data:', error);
        toast.error('Failed to load dashboard data');
      } finally {
        setLoading(false);
      }
    };
    
    fetchPollsterData();
  }, [userId]);

  return {
    pollStats,
    loading,
    documents
  };
};
